import { EyeOffOutlineIcon } from './EyeOffOutlineIcon';

/**
 * author: Austin Andrews
 * id D88D00BE-0B70-40F5-AFD0-51C65DE8D674
 * name eye-off-outline
 * version: 1.8.36
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/eye-off-outline.svg
 * tags
 */
export const HideOutlineIcon = EyeOffOutlineIcon;
export default HideOutlineIcon